module.exports = __webpack_public_path__ + "img/courses3.aa480184.jpg";